import {
    isSubscribable,
    observable,
    Observable,
} from "knockout";

import { BackgroundTasksService } from "../../backend/v1/services.gen";
import { BackgroundTaskStatus } from "../../backend/v1/types.gen";


interface BackgroundTaskStatusParams {
    taskId: string | Observable<string>;
    onFinalState?: (state: "succeeded" | "failed") => void;
}


class BackgroundTaskStatusViewModel {

    public readonly taskId: Observable<string>;
    public readonly status: Observable<BackgroundTaskStatus | undefined>;
    private readonly inProgress: Observable<boolean>;

    constructor(params: BackgroundTaskStatusParams) {

        this.status = observable();
        this.inProgress = observable(true);
        this.taskId = isSubscribable(params.taskId) ? params.taskId : observable(params.taskId);

        this.taskId.subscribe((taskId) => {
            if (taskId) {
                const interval: NodeJS.Timeout = setInterval(() => BackgroundTasksService
                    .getBackgroundTaskStatus({ taskId })
                    .then((status) => {
                        this.status(status);
                        if (status.state === "started" || status.state === "waiting") {
                            this.inProgress(true);
                        } else if (status.state === "succeeded" || status.state === "failed") {
                            clearInterval(interval);
                            this.inProgress(false);
                            if (typeof params.onFinalState === "function") {
                                params.onFinalState(status.state);
                            }
                        }
                    })
                    .catch(() => clearInterval(interval)),
                6_000);
            }
        });
    }

}


export const getBackgroundTaskStatusComponent = () => ({
    viewModel: BackgroundTaskStatusViewModel,
    template: `
        <span>
            <span data-bind="visible: inProgress()"
                  style="margin: 0 30px 0 20px; line-height: 24px;">
                <span class="two_bubbles_loader_container"
                      style="position: relative">
                    <div class="two_bubbles_loader"></div>
                </span>
            </span>
            <span class="icon_button icon_type_confirm only_icon_img"
                  data-bind="visible: !status(),
                             attr: {title: getTranslation('unknown')}"></span>
            <span class="icon_button icon_type_success only_icon_img"
                  data-bind="visible: status() && status().state == 'succeeded',
                             attr: {title: getTranslation('succeeded')}"></span>
            <span class="icon_button icon_type_error only_icon_img"
                  data-bind="visible: status() && status().state == 'failed',
                             attr: {title: getTranslation('failed')}"></span>
            <!-- ko if: status() && status().total_count && status().completed_count -->
                <span data-bind="text: _.template(getTranslation('<%- completed_count %> of <%- total_count %>'))(status())">
                </span>
            <!-- /ko -->
        </span>
    `,
});
